module.exports = __webpack_public_path__ + "static/media/puzzle-36-bg.c6751eff.svg";